module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAOCAYAAADjXQYbAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4woYBzsPKltAcQAAAQtJREFUGNNV0L1KXGEYReHn/c4haECUWDj4E6sUjgOjYGVloWCl4FWYUqLeQiCCdcgtBNJJGhs7qwGZ0TbRRBAkjcHBBM/5LKJgVrvYLNjhkeUDMTdtDRvCK5QBO11jOcxjCiMC1CUIbbxFJ4XPuKzol7u9gdWsHqc+IXeKqL6/b+pDyup1iuGI4S+RJo+exO4pKbtvZH8Tzvea5zeeUVIPQq5/3cD26RD4MPtbKSR4UchQ5/7zpWvku8q4T37utypweEHCWeYP2luLpv9rRvgqexMsobHTdXR169vya1Xaa+okfgRjQQvt0ZemFo4f73vXM5KzmRQmMIqBTBEfe2y2/jW2umaLsII2Gg9EeFGjZr9DdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/ilol.png
// module id = LxtC
// module chunks = 1